import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { R2_HEALTH_PATH } from '@common/types/api/health';
import { environment } from '@env';
import { HealthService } from '@services/health/health.service';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor
{
    constructor(private health: HealthService)
    {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const isRelativeApiRequest = request.url.startsWith('/api/');
        const isOfficeApiRequest = request.url.startsWith(`${ environment.office_api_host }/api/`);
        const isHealthApiRequest = request.url.startsWith(`${ environment.health_api_host }/api/`);
        if (!isRelativeApiRequest && !isOfficeApiRequest && !isHealthApiRequest) return next.handle(request);

        const isHealthProbe = request.url === R2_HEALTH_PATH
            || request.url === environment.office_api_host + R2_HEALTH_PATH
            || request.url === environment.health_api_host + R2_HEALTH_PATH;
        const targetHost = request.url === R2_HEALTH_PATH
            ? environment.health_api_host
            : environment.office_api_host;
        const apiRequest = request.clone({
            url: isRelativeApiRequest ? targetHost + request.url : request.url,
            withCredentials: isHealthProbe ? false : request.withCredentials,
            headers: isHealthProbe ? request.headers.delete('Authorization') : request.headers,
        });

        return next.handle(apiRequest).pipe(
            catchError((error) =>
            {
                if (!isHealthProbe)
                {
                    void this.health.refresh();
                }

                return throwError(() => error);
            }),
        );
    };

}
